import { render } from "./ComingSoon.vue?vue&type=template&id=043c7fc7&ts=true"
import script from "./ComingSoon.vue?vue&type=script&lang=ts"
export * from "./ComingSoon.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../sf-playbook-app/APP/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__